/**
 * Quantity Custom Input Component
 * Provides a custom quantity input with up/down buttons
 */
class QuantityCustomInput extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init();
    }, 1000);
  }

  init() {
    // Get elements
    this.input = this.querySelector(".quantity-custom__input");
    this.upButton = this.querySelector(".quantity-custom__button--up");
    this.downButton = this.querySelector(".quantity-custom__button--down");

    // Exit if elements not found
    if (!this.input || !this.upButton || !this.downButton) {
      console.error("Quantity input elements not found");
      return;
    }

    // Get min/max values
    this.min = Number(this.input.getAttribute("min") || 1);
    this.max = Number(this.input.getAttribute("max") || Infinity);

    // Force enable buttons
    this.upButton.removeAttribute("disabled");
    this.upButton.classList.remove("disabled");
    this.upButton.setAttribute("aria-disabled", "false");

    this.downButton.removeAttribute("disabled");
    this.downButton.classList.remove("disabled");
    this.downButton.setAttribute("aria-disabled", "false");

    // We're now using inline onclick handlers, so we don't need these event listeners
    // this.upButton.onclick = this.onUpButtonClick.bind(this);
    // this.downButton.onclick = this.onDownButtonClick.bind(this);

    // Only keep the input change handler
    this.input.onchange = this.onInputChange.bind(this);

    // Initialize button states
    this.updateButtonStates();
  }

  onInputChange() {
    // Ensure the value is a valid number
    let value = Number(this.input.value);

    // If not a valid number, reset to minimum
    if (isNaN(value) || value === "") {
      value = this.min;
    }

    // Ensure value is within min/max bounds
    value = Math.max(this.min, Math.min(this.max, value));

    // Update the input if the value was changed
    if (Number(this.input.value) !== value) {
      this.input.value = value;
    }

    this.updateButtonStates();
  }

  updateButtonStates() {
    const value = Number(this.input.value);

    // Update up button state
    if (value >= this.max) {
      this.upButton.setAttribute("disabled", "");
      this.upButton.classList.add("disabled");
      this.upButton.setAttribute("aria-disabled", "true");
    } else {
      this.upButton.removeAttribute("disabled");
      this.upButton.classList.remove("disabled");
      this.upButton.setAttribute("aria-disabled", "false");
    }

    // Update down button state
    if (value <= this.min) {
      this.downButton.setAttribute("disabled", "");
      this.downButton.classList.add("disabled");
      this.downButton.setAttribute("aria-disabled", "true");
    } else {
      this.downButton.removeAttribute("disabled");
      this.downButton.classList.remove("disabled");
      this.downButton.setAttribute("aria-disabled", "false");
    }
  }
}

// Register the custom element
if (!customElements.get("quantity-custom-input")) {
  customElements.define("quantity-custom-input", QuantityCustomInput);
}

// Also add a fallback initialization for any existing elements
document.addEventListener("DOMContentLoaded", function() {
  const quantityInputs = document.querySelectorAll("quantity-custom-input");
  quantityInputs.forEach(input => {
    if (input instanceof QuantityCustomInput) {
      input.init();
    }
  });
});
